import { forwardRef } from 'react';
import './FlexibleMatchingActivityPrompt.scss';
import { Box } from '@mui/material';
import CardActivity from '../../common/card-activity/CardActivity';
import { defaultSubmitText } from '../../../../../utils/activitytype/ActivityTypeInitialData';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onClick: () => null,
  submitAnswerText: null,
  onSwitchAccessSelected: () => null,
};
const FlexibleMatchingActivityPrompt = forwardRef((props, ref) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onClick, submitAnswerText, onSwitchAccessSelected } = mergedProps;
  return (
    <Box className='flexible-matching-activity-prompt'>
      <CardActivity
        text={submitAnswerText || defaultSubmitText}
        className='flexible-matching-activity-prompt-card'
        ref={ref}
        onClick={onClick}
        fontScale={0.9}
        onSwitchAccessSelected={onSwitchAccessSelected}
      />
    </Box>
  );
});

export default FlexibleMatchingActivityPrompt;
